import React from 'react'
import styles from './JamoBlock.module.scss'

// One syllable block drawn from its letters, so each letter can be coloured and
// scaled on its own. No font can do that: a syllable is a single glyph, and
// splitting it into spans breaks the shaping. So the block is assembled here in
// the classroom layouts — initial left / vowel right for tall vowels, initial
// over vowel for flat ones, the vowel wrapping for compound ones, and a final
// along the bottom. Slightly schematic, but it reads as Hangul.
//
//   states: { L: 'idle'|'lit'|'hit'|'near'|'miss', V: …, T: … }
//   onPart(part): a tap on one letter

// [x, y, fontSize] in a 100×100 box. `Lt`/`Vt` are the positions when a final
// is present (the top row squeezes up to make room).
// With a final, everything is pulled in a little so the lit-up scale (×1.12)
// still stays inside the box — a final along the bottom is the tight spot.
const POS = {
  vertical:   { L: [31, 50, 46], V: [72, 50, 50], Lt: [31, 34, 38], Vt: [72, 34, 42], T: [50, 78, 31] },
  horizontal: { L: [50, 33, 42], V: [50, 70, 44], Lt: [50, 25, 34], Vt: [50, 54, 36], T: [50, 80, 29] },
  compound:   { L: [31, 33, 42], V: [64, 57, 50], Lt: [30, 26, 34], Vt: [64, 45, 42], T: [50, 80, 29] },
}

export default function JamoBlock({ syl, states = {}, size = 120, onPart, className = '' }) {
  if (!syl || !syl.parts || !syl.parts.length) {
    return (
      <div className={`${styles.block} ${styles.plainBox} ${className}`} style={{ width: size, height: size }}>
        <span className={styles.plain}>{syl?.ch}</span>
      </div>
    )
  }
  const withFinal = !!syl.T
  const P = POS[syl.layout] || POS.vertical
  return (
    <svg className={`${styles.block} ${className}`} viewBox="0 0 100 100" width={size} height={size} role="img" aria-label={syl.ch}>
      {syl.parts.map((p) => {
        const key = p.role === 'T' ? 'T' : (withFinal ? p.role + 't' : p.role)
        const [x, y, fs] = P[key]
        const st = (states && states[p.role]) || 'idle'
        return (
          <text key={p.role} x={x} y={y} fontSize={fs} textAnchor="middle" dominantBaseline="central"
            className={`${styles.part} ${styles[st] || ''}`}
            onClick={onPart ? (e) => { e.stopPropagation(); onPart(p) } : undefined}>
            {p.jamo}
          </text>
        )
      })}
    </svg>
  )
}
